import { z } from 'zod'

/** Limite não informado pela API; 100 cobre nomes como "CELULAR DO JOÃO". */
export const NOME_DISPOSITIVO_MAX = 100

export const aparelhoSchema = z.object({
  nomeDispositivo: z
    .string()
    .trim()
    .min(1, 'Informe um nome para o aparelho')
    .max(NOME_DISPOSITIVO_MAX, `Use no máximo ${NOME_DISPOSITIVO_MAX} caracteres`)
    .transform((nome) => nome.toUpperCase()),
})

export type AparelhoFormInput = z.input<typeof aparelhoSchema>
export type AparelhoFormValues = z.output<typeof aparelhoSchema>
